import { render, staticRenderFns } from "./QuestionTwo.vue?vue&type=template&id=fbf7915a&scoped=true&"
import script from "./QuestionTwo.vue?vue&type=script&lang=js&"
export * from "./QuestionTwo.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTwo.vue?vue&type=style&index=0&id=fbf7915a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf7915a",
  null
  
)

export default component.exports